import type { Slicer } from '@swf/core/store';

import type { SportsEventInfoState } from './types';

export const selectors = (slice: Slicer<SportsEventInfoState>) => ({
  eventInfo: () => slice((state) => state.eventInfo),
  isLoading: () => slice((state) => state.isLoading),
  errorCode: () => slice((state) => state.errorCode),
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  hasTeamStats: () => slice((state) => state.hasTeamStats)
});
